import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Label from './Label';

const AdvisorInformation = ({
  uniqueId,
  labelClass,
  question,
  handleQuestionChange,
}) => (
  <div className="col-md-6">
    <div
      className={classNames('form-group', {
        'has-error': question.hasError,
      })}
    >
      <Label
        name={uniqueId || question.name}
        className={labelClass}
        text={question.label}
        required={question.required}
      />
      <input
        type="text"
        id={uniqueId || question.name}
        value={question.value}
        className={classNames('srp-form-input form-control', {
          'is-invalid': question.hasError,
          'is-dirty': question.dirty,
        })}
        maxLength="10"
        onChange={(e) => {
          let toNumber = e.target.value.replace(/[^0-9]/g, '');
          toNumber = toNumber.replace(/^0+/, '');
          handleQuestionChange(question.name, toNumber);
        }}
      />
      <small>
        (Your NPN is a number between 4-10 digits in length. Not sure what your
        NPN is?{' '}
        <a href=" https://nipr.com/help/look-up-your-npn" target="_blank">
          Find it here
        </a>
        )
      </small>
    </div>
  </div>
);

AdvisorInformation.propTypes = {
  uniqueId: PropTypes.string,
  labelClass: PropTypes.string,
  question: PropTypes.object.isRequired,
  handleQuestionChange: PropTypes.func.isRequired,
};

export default AdvisorInformation;
